/**
 * Shopify session / visitor tracking for custom headless (Phase 3).
 *
 * Uses hydrogen-react useShopifyCookies({ fetchTrackingValues: true }) so the
 * browser hits same-origin /api/unstable/graphql.json (Netlify edge proxy → Shopify).
 * That sets HTTP-only analytics cookies + server-timing; getTrackingValues() /
 * getClientBrowserParameters() then supply uniqueToken / visitToken.
 *
 * Deprecated _shopify_y / _shopify_s are still refreshed for backward compatibility
 * until Shopify removes them (Apr 30, 2026). Options passed as primitives so the
 * hook does not re-fetch / rewrite on every unrelated React render.
 */
import { useMemo } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useShopifyCookies } from "@shopify/hydrogen-react";
import { STOREFRONT_TOKEN, SHOPIFY_HEADLESS_TOKEN } from "utils/constants";

/** Shared root with checkout at shop.sealskincovers.com */
export const SHOPIFY_COOKIE_DOMAIN = ".sealskincovers.com";
export const SHOPIFY_CHECKOUT_DOMAIN = "shop.sealskincovers.com";

const getStorefrontAccessToken = () => SHOPIFY_HEADLESS_TOKEN || STOREFRONT_TOKEN || "";

/**
 * @returns true when tracking cookies / server-timing values are ready
 */
export const useShopifyTrackingCookies = (hasUserConsent = true) => {
    const storefrontAccessToken = useMemo(() => getStorefrontAccessToken(), []);

    return useShopifyCookies({
        hasUserConsent,
        domain: SHOPIFY_COOKIE_DOMAIN,
        checkoutDomain: SHOPIFY_CHECKOUT_DOMAIN,
        storefrontAccessToken,
        fetchTrackingValues: true,
    });
};
